/**
 * 预览子组件-预览iframe组件
 * @author chenqunfeng
 * @since 18/05/07
 */

import './iframe.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as url from '@fe/common/lib/url';
import * as qs from '@fe/common/lib/query-string';
import { isShowStoreTemplateQRCode, showRabbitBrandInfo } from 'utils/user';
import VARIABLES from 'constants/variable.json5';
import store from 'store';

const IFRAME_WIDTH = 320;
const IFRAME_HEIGHT = 504;

class PreviewPrice extends Component {
  static propTypes = {
    data: PropTypes.object,
    newClassName: PropTypes.string,
    needLoading: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  getLoading() {
    const { needLoading } = this.props;

    if (!needLoading) {
      return null;
    }

    return (
      <div
        className="loading-mask"
        ref={loadingMask => (this.loadingMask = loadingMask)}>
        <figure>
          <div className="dot white" />
          <div className="dot" />
          <div className="dot" />
          <div className="dot" />
          <div className="dot" />
        </figure>
      </div>
    );
  }

  onLoad() {
    this &&
      this.loadingMask &&
      this.loadingMask.classList &&
      this.loadingMask.classList.add('fadeOut');
    const parent = this.loadingMask && this.loadingMask.parentNode;

    setTimeout(() => {
      // this && this.loadingMask && this.loadingMask.remove();
      if (parent && this.loadingMask) {
        parent.removeChild(this.loadingMask);
      }
    }, 599);
  }

  componentDidMount() {
    if (this.iframe) {
      // refer to: https://developers.google.com/web/updates/2017/09/autoplay-policy-changes#iframe
      this.iframe.setAttribute('allow', 'autoplay; fullscreen');

      this.iframe.setAttribute('allowFullScreen', true);
      this.iframe.setAttribute('webkitAllFullScreen', true);
      this.iframe.setAttribute('mozAllowFullScreen', true);
    }
  }

  renderScrollTip() {
    return (
      <div className="s-preview-poster-tips">
        <span>按住鼠标可滑动</span>
        <i className="s-icon icon-huadong" />
      </div>
    );
  }

  render() {
    let { data, newClassName = '' } = this.props;
    let { pluginId, previewUrl, type, width, height } = data;

    const ratio = width && height ? width / height : null;
    const posterHeight = ratio
      ? Math.floor(IFRAME_WIDTH / ratio)
      : IFRAME_HEIGHT;

    // 显式声明mobile和autoplay
    const query = qs.parse(previewUrl);
    const urlObj = url.parse(previewUrl);
    const { path = '', hostWidthPort = '' } = urlObj;
    query.mobile = 1;
    query.autoplay = 1;
    query.hideTemplateLoadingLogo = showRabbitBrandInfo() ? false : true;
    const userState = store.getState();
    if (userState && userState.userInfo) {
      query.userOpfId = userState.userInfo.userOpfId;
      query.userPfid = userState.userInfo.userPfid;
    }
    //临时修复
    query.preview = 1;
    previewUrl = '//' + hostWidthPort + path + '?' + qs.stringify(query);

    if (previewUrl) {
      newClassName = `s-preview-iframe ${newClassName}`;
      return (
        <div className={newClassName}>
          {pluginId && isShowStoreTemplateQRCode() && (
            <div className="s-preview-tips">微信扫一扫，在手机端体验活动</div>
          )}
          <iframe
            ref={iframe => (this.iframe = iframe)}
            onLoad={this.onLoad.bind(this)}
            src={previewUrl}
            scrolling="no"
          />
          {type === VARIABLES.POSTER && posterHeight > IFRAME_HEIGHT
            ? this.renderScrollTip()
            : ''}
          {this.getLoading()}
        </div>
      );
    } else {
      return <div className="s-preview-iframe" />;
    }
  }
}

export default PreviewPrice;
